import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-487">
      <div className="flex flex-col items-center" data-id="element-488">
        <div className="bg-navy-900 border border-dark-border text-white text-2xl sm:text-3xl md:text-5xl font-heading font-bold py-2 px-3 sm:py-3 sm:px-4 rounded-lg min-w-[60px] sm:min-w-[80px]" data-id="element-489">
          {pad(timeLeft.hours)}
        </div>
        <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest" data-id="element-490">
          Horas
        </span>
      </div>
      <span className="text-2xl sm:text-3xl md:text-5xl font-bold text-gold pb-6" data-id="element-491">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-492">
        <div className="bg-navy-900 border border-dark-border text-white text-2xl sm:text-3xl md:text-5xl font-heading font-bold py-2 px-3 sm:py-3 sm:px-4 rounded-lg min-w-[60px] sm:min-w-[80px]" data-id="element-493">
          {pad(timeLeft.minutes)}
        </div>
        <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest" data-id="element-494">
          Min
        </span>
      </div>
      <span className="text-2xl sm:text-3xl md:text-5xl font-bold text-gold pb-6" data-id="element-495">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-496">
        <div className="bg-navy-900 border border-dark-border text-white text-2xl sm:text-3xl md:text-5xl font-heading font-bold py-2 px-3 sm:py-3 sm:px-4 rounded-lg min-w-[60px] sm:min-w-[80px]" data-id="element-497">
          {pad(timeLeft.seconds)}
        </div>
        <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest" data-id="element-498">
          Seg
        </span>
      </div>
    </div>;
}